import { Direction } from "../../../../types/battle-engine/battle";
import { SkillCastPattern } from ".";

export const FRONTAL_WAVE_3_5_PATTERN: SkillCastPattern = () => {
  return {
    [Direction.N]: [
      [0, -1],
      [-1, -1],
      [1, -1, true], // Blocks event pipeline
      [0, -2],
      [-1, -2],
      [1, -2, true], // Blocks event pipeline
      [0, -3],
      [-1, -3],
      [1, -3, true], // Blocks event pipeline
      [0, -4],
      [-1, -4],
      [1, -4, true], // Blocks event pipeline
      [0, -5],
      [-1, -5],
      [1, -5],
    ],

    [Direction.NE]: [
      [0, -1],
      [1, 0],
      [1, -1, true], // Blocks event pipeline
      [1, -2],
      [2, -1],
      [2, -2, true], // Blocks event pipeline
      [2, -3],
      [3, -2],
      [3, -3, true], // Blocks event pipeline
      [3, -4],
      [4, -3],
      [4, -4],
    ],

    [Direction.E]: [
      [1, 0],
      [1, -1],
      [1, 1, true], // Blocks event pipeline
      [2, 0],
      [2, -1],
      [2, 1, true], // Blocks event pipeline
      [3, 0],
      [3, -1],
      [3, 1, true], // Blocks event pipeline
      [4, 0],
      [4, -1],
      [4, 1, true], // Blocks event pipeline
      [5, 0],
      [5, -1],
      [5, 1],
    ],

    [Direction.SE]: [
      [0, 1],
      [1, 0],
      [1, 1, true], // Blocks event pipeline
      [1, 2],
      [2, 1],
      [2, 2, true], // Blocks event pipeline
      [2, 3],
      [3, 2],
      [3, 3, true], // Blocks event pipeline
      [3, 4],
      [4, 3],
      [4, 4],
    ],

    [Direction.S]: [
      [0, 1],
      [-1, 1],
      [1, 1, true], // Blocks event pipeline
      [0, 2],
      [-1, 2],
      [1, 2, true], // Blocks event pipeline
      [0, 3],
      [-1, 3],
      [1, 3, true], // Blocks event pipeline
      [0, 4],
      [-1, 4],
      [1, 4, true], // Blocks event pipeline
      [0, 5],
      [-1, 5],
      [1, 5],
    ],

    [Direction.SW]: [
      [-1, 0],
      [0, 1],
      [-1, 1, true], // Blocks event pipeline
      [-2, 1],
      [-1, 2],
      [-2, 2, true], // Blocks event pipeline
      [-3, 2],
      [-2, 3],
      [-3, 3, true], // Blocks event pipeline
      [-4, 3],
      [-3, 4],
      [-4, 4],
    ],

    [Direction.W]: [
      [-1, 0],
      [-1, -1],
      [-1, 1, true], // Blocks event pipeline
      [-2, 0],
      [-2, -1],
      [-2, 1, true], // Blocks event pipeline
      [-3, 0],
      [-3, -1],
      [-3, 1, true], // Blocks event pipeline
      [-4, 0],
      [-4, -1],
      [-4, 1, true], // Blocks event pipeline
      [-5, 0],
      [-5, -1],
      [-5, 1],
    ],

    [Direction.NW]: [
      [-1, 0],
      [0, -1],
      [-1, -1, true], // Blocks event pipeline
      [-2, -1],
      [-1, -2],
      [-2, -2, true], // Blocks event pipeline
      [-3, -2],
      [-2, -3],
      [-3, -3, true], // Blocks event pipeline
      [-4, -3],
      [-3, -4],
      [-4, -4],
    ],
  };
};
